import React from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import { TicketUpdatePage } from './TicketUpdatePage'
import { TicketDelete } from './TicketDelete'
import {RepairCreateButton} from "../Repairs";
const getRowStyle = (ticket, rowIndex) => {
  const style = {}
  if (ticket.is_deleted) {
    style.borderLeft = '10px solid Red'
    return style
  }
  if (
    [
      'Under Progress'.toLowerCase(),
      'registered'.toLowerCase(),
      'Hold'.toLowerCase(),
    ].includes(ticket.status.toLowerCase())
  ) {
    style.borderLeft = '10px solid orange'
    return style
  }
  if (
    [
      'Delivered'.toLowerCase(),
      'DECLINED'.toLowerCase(),
      'PROCESSED FOR REPLACEMENT'.toLowerCase(),
    ].includes(ticket.status.toLowerCase())
  ) {
    style.borderLeft = '10px solid Green'
    return style
  }

  style.borderLeft = '10px solid Black'
  return style
}



export const TicketsDataGrid = ({
  results,
  page_size,
  current,
  count,
  onFilter,
  handleTableChange,
  children,
  hiddenRowKeys,
  onDelete,
  showOnlyPages,
  title,
}) => {
  const actionFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <ReactBootstrap.Dropdown>
        <ReactBootstrap.Dropdown.Toggle
          variant="dark"
          size="sm"
        ></ReactBootstrap.Dropdown.Toggle>
        <ReactBootstrap.Dropdown.Menu>

           <components.Slider
            buttonType="dropdown"
            header={
              <span>
                {components.ICONS.EDIT} Update
                {row.reference_number}
              </span>
            }
            title={
              <span className="">
                {components.ICONS.EDIT} Update
              </span>
            }
          >
            <TicketUpdatePage
            buttonType="dropdown"
            purchaseOrderNumber={row.reference_number}
            header={
              <span>
                {components.ICONS.EDIT} Update {row.reference_number}
              </span>
            }
            title={<span className="">{components.ICONS.EDIT} Update</span>}
          />
          </components.Slider>



          <components.Slider
            buttonType="dropdown"
            header={
              <span>
                {components.ICONS.PLUS} Proposed Data For GSX Repair
                {row.reference_number}
              </span>
            }
            title={
              <span className="">
                {components.ICONS.PLUS} Create GXS Repair
              </span>
            }
          >
            <RepairCreateButton ticket={row} />
          </components.Slider>

          <TicketDelete onDeletion={onDelete} ticket={row} />
      </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>
    )
  }
  const columns = [
    {
      dataField: 'reference_number',
      text: 'Reference Number',
      type: 'string',
      formatter: (cell, row) => (
        <a
          className="text-dark"
          target={'_blank'}
          href={`/dashboard/ticket/${cell}`}
          rel="noreferrer"
        >
          {cell}
        </a>
      ),
      searchFieldType: 'text',
    },
    {
      dataField: 'device',
      text: 'Device',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'text',
      hidden: true,
    },
    {
      dataField: 'customer',
      text: 'Customer',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'text',
      hidden: true,
    },
    {
      dataField: 'created_by',
      text: 'Created By Name',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'text',
      hidden: true,
    },
    {
      dataField: 'coverage_type',
      text: 'Coverage Type',
      sort: true,
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'repair_type',
      text: 'Product',
      type: 'string',
      formatter: components.CellTextFormatter,
    },
    {
      dataField: 'status',
      text: 'Status',
      type: 'string',
      formatter: components.CellTextFormatter,
    },
    {
      dataField: 'created_at',
      text: 'Created On',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'date',
    },

    {
      dataField: '',
      text: '',
      isDummyField: true,
      formatter: actionFormatter,
    },
  ]

  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>{title || 'Tickets'}</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-white text-end" xs={6}>
            <components.Slider
              title={components.ICONS.SEARCH}
              sliderWidth={"20vw"}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-1"> Tickets</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>

            {children}
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          rowStyle={getRowStyle}
          keyField="url"
          data={results || []}
          sizePerPage={page_size || 10}
          current={current || 1}
          page={current}
          columns={columns}
          count={count || 0}
          onTableChange={handleTableChange}
          hiddenRows={hiddenRowKeys}
          showOnlyPages={showOnlyPages}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
